enum DefaultRangeTime {
  StartHour = 0,
  StartMin = 0,
  StartSec = 0,
  StartMs = 0,
  EndHour = 23,
  EndMin = 59,
  EndSec = 59,
  EndMs = 999,
}

export default DefaultRangeTime;
